module.exports = __webpack_public_path__ + "img/empty-barmen-red.62cee95.svg";